import { B2bComponent } from '../b2b.component';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {B2BService} from 'src/app/b2-b.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  constructor(public parent: B2bComponent, private B2BService:B2BService, private managementService:ManagementServiceService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) { 
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  Password:string;
  NewPassword:string;
  ConfirmNewPassword:string;

  hide:boolean;
  hideNewPass:boolean;
  hideConfirmNewPass:boolean;

  B2BPartner:any;

  Currencies:any[];
  PrefferedCurrency:any;

  // Dropdown toggle flags
  showLanguageDropdown: boolean = false;
  showCurrencyDropdown: boolean = false;
  showAddressDropdown: boolean = false;
  showCountryDropdown: boolean = false;

  // Available languages for dropdown
  AvailableLanguages: any[] = [
    { Name: 'en' }, { Name: 'ro' }, { Name: 'de' }, { Name: 'es' },
    { Name: 'fr' }, { Name: 'it' }, { Name: 'pl' }, { Name: 'pt' }
  ];

  ngOnInit(): void {
    this.hide = true;
    this.hideNewPass = true;
    this.hideConfirmNewPass = true;
    this.GetB2BUserConnectedPartner(this.parent.User);
    this.GetOrdersMasterData();
    this.GetUserB2BSettings();
  }

  selectText(event: Event): void {
    const target = event.target as HTMLTextAreaElement;
    target.select();
  }

  // Dropdown selection methods
  selectLanguage(lang: any): void {
    this.parent.User.Settings.Language = lang;
    this.parent.ChangeLanguage(lang);
  }

  selectCurrency(c: any): void {
    this.parent.User.B2BSettings.PrefferedCurrency = c;
    this.UpdateUser();
  }

  selectAddress(a: any): void {
    this.CurrentShippingAddress = a;
    this.FindCurrentChangeRequest();
  }

  selectCountry(c: any): void {
    this.CurrentShippingAddress.Country = c;
  }
  
  GetOrdersMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };
  
    this.B2BService.GetOrdersMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Currencies = JSON.parse(JSON.stringify(response["Currencies"]));

        if(this.parent.User.PrefferedCurrency == null){
          this.parent.User.PrefferedCurrency = this.Currencies.filter(x => x.IsInternationalCurrency == true)[0];
          localStorage.setItem('User', JSON.stringify(this.parent.User));
        }
      }
    });
  }

  GetB2BUserConnectedPartner(user:any){

    var request = {
      User:user,
      Language:this.parent.getLanguage(),
    };
  
    this.B2BService.GetB2BUserConnectedPartner(request).subscribe(response => {

      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.B2BPartner = response["Partner"];
        this.GetPartnerShippingAddresses(this.B2BPartner.ID);
      }
    });
  }

  UpdateUser(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage()
    };

    this.parent.loading = true;

    this.service.UpdateUser(request).subscribe(response => {
   
      if(response["Status"] != 1){
        
      }
      else if(response["Status"] == 1){

        var previousUser = JSON.parse(localStorage.getItem("User"));
        localStorage.setItem('User', JSON.stringify(this.parent.User));

        if(previousUser.B2BSettings.PrefferedCurrency.ID != this.parent.User.B2BSettings.PrefferedCurrency.ID)
        {
          this.parent.ClearGrid();
        }
      }
   
      this.parent.loading = false;
    });
  }

  ChangeUserPassword(){

    var request = {
      User:this.parent.User,
      Password:this.Password,
      NewPassword:this.NewPassword,
      ConfirmNewPassword:this.ConfirmNewPassword,
      Language:this.parent.getLanguage()
    };

    this.parent.loading = true;

    this.service.ChangeUserPassword(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
   
      this.parent.loading = false;
    });
  }

  ShowMyData:boolean = true;
  ShowBilling:boolean = false;
  ShowShipping:boolean = false;
  LoadShippingAddresses:boolean = false;
  CurrentShippingAddress:any;
  CurrentShippingAddressChangeRequest:any;
  ShippingAddressChangeRequests:any[];

  AddPartnerShippingAddressChangeRequest(address:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ShippingAddress:address
    };
  
    this.B2BService.AddPartnerShippingAddressChangeRequest(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentShippingAddressChangeRequest = response["ShippingAddressChangeRequest"];
      }
    });
  }

  GetShippingAddresses(){
    if(this.B2BPartner?.ID){
      this.GetPartnerShippingAddresses(this.B2BPartner.ID);
    }
  }

  GetPartnerShippingAddresses(PartnerID:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:PartnerID
    };

    this.LoadShippingAddresses = true;
    this.service.GetPartnerShippingAddresses(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.B2BPartner.ShippingAddresses = response["ShippingAddresses"];
        this.CurrentShippingAddress = this.B2BPartner.ShippingAddresses[0];
        this.GetPartnerShippingAddressChangeRequest(this.B2BPartner.ID);
      }
   
      this.LoadShippingAddresses = false;
    });
  }

  GetPartnerShippingAddressChangeRequest(PartnerID:string){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:PartnerID
    };

    this.LoadShippingAddresses = true;
    this.B2BService.GetPartnerShippingAddressChangeRequest(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShippingAddressChangeRequests = response["ShippingAddressChangeRequests"];
        this.FindCurrentChangeRequest();
      }
   
      this.LoadShippingAddresses = false;
    });
  }

  GetUserB2BSettings(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;
    this.service.GetUserB2BSettings(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.User.B2BSettings = JSON.parse(JSON.stringify(response["B2BSettings"]));
      }
   
      this.parent.loading = false;
    });
  }

  openExternalPartnerProfile(): void {
    if (!this.B2BPartner?.ID) return;
    const baseUrl = window.location.origin;
    const url = `${baseUrl}/external/partner?id=${this.B2BPartner.ID}`;
    window.open(url, '_blank');
  }

  FindCurrentChangeRequest(){
    this.CurrentShippingAddressChangeRequest = null;

    if(this.ShippingAddressChangeRequests != null){
      for(var i=0; i < this.ShippingAddressChangeRequests.length; i++){
        if(this.ShippingAddressChangeRequests[i].RequestingShippingAddressID == this.CurrentShippingAddress.ID){
          this.CurrentShippingAddressChangeRequest = this.ShippingAddressChangeRequests[i];
        }
      }
    }
  }

  // ===========================
  // Self-Service Management
  // ===========================
  SelfServiceTab: number = 1; // 1=Billing, 2=Shipping, 3=Agents
  Countries: any[] = [];
  showBillingCountryDropdown: boolean = false;

  // -- Shipping tab state --
  EditingShippingAddress: any = null;
  ShowNewShippingAddressForm: boolean = false;
  NewShippingAddress: any = {};
  showNewShippingCountryDropdown: boolean = false;
  ShowZipCodeWarning: boolean = false;

  // -- Agents tab state --
  PartnerAgents: any[] = [];
  EditingAgent: any = null;
  ShowNewAgentForm: boolean = false;
  NewAgent: any = {};
  Departments: any[] = [];
  showNewAgentDepartmentDropdown: boolean = false;
  ShowAgentEmailWarning: boolean = false;

  // -- Agent Notification Phases state --
  showDefaultPhasesPopup: boolean = false;
  selectedDefaultPhaseAgent: any = null;
  defaultPhasesMasterData: any[] = [];
  selectedDefaultPhaseIDs: number[] = [];
  savingDefaultPhases: boolean = false;

  SelectSelfServiceTab(tab: number){
    this.SelfServiceTab = tab;
    if(tab == 1 && this.Countries.length == 0){
      this.LoadCountries();
    }
    if(tab == 2){
      if(this.Countries.length == 0) this.LoadCountries();
    }
    if(tab == 3){
      this.LoadPartnerAgents();
      this.LoadDepartments();
    }
  }

  LoadCountries(){
    if(this.Countries.length > 0) return;
    var request = { User: this.parent.User, Language: this.parent.getLanguage() };
    this.service.GetPartnersMasterData(request).subscribe(response => {
      if(response["Status"] == 1){
        this.Countries = response["Countries"] || [];
      }
    });
  }

  LoadDepartments(){
    if(this.Departments.length > 0 || !this.B2BPartner?.ID) return;
    var request = { User: this.parent.User, Language: this.parent.getLanguage(), PartnerID: this.B2BPartner.ID };
    this.service.InitializePartnerAgent(request).subscribe(response => {
      if(response["Status"] == 1){
        this.Departments = response["Departments"] || [];
      }
    });
  }

  // -- Billing --
  SaveBillingInfo(){
    if(!this.B2BPartner?.ID) return;
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Partner: this.B2BPartner
    };

    this.parent.loading = true;
    this.service.UpdatePartner(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      } else {
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      this.parent.loading = false;
    });
  }

  // -- Shipping --
  EditShippingAddress(a: any){
    this.EditingShippingAddress = JSON.parse(JSON.stringify(a));
    this.ShowNewShippingAddressForm = false;
  }

  CancelEditShippingAddress(){
    this.EditingShippingAddress = null;
  }

  SaveEditingShippingAddress(){
    if(!this.EditingShippingAddress) return;
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ShippingAddress: this.EditingShippingAddress,
      PartnerID: this.B2BPartner.ID
    };
    this.parent.loading = true;
    this.service.AddUpdateShippingAddress(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      } else {
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.EditingShippingAddress = null;
        this.GetPartnerShippingAddresses(this.B2BPartner.ID);
      }
      this.parent.loading = false;
    });
  }

  OpenNewShippingAddressForm(){
    this.ShowNewShippingAddressForm = true;
    this.EditingShippingAddress = null;
    this.ShowZipCodeWarning = false;
    this.NewShippingAddress = {
      ID: 0,
      ContactPerson: '',
      ContactCompany: this.B2BPartner?.Name || '',
      Country: this.B2BPartner?.BillingAddress?.Country || null,
      State: '',
      City: '',
      AddressLine: '',
      ZipCode: '',
      Phone: '',
      Email: '',
    };
  }

  CheckZipCodeDuplicate(){
    this.ShowZipCodeWarning = false;
    if(!this.NewShippingAddress.ZipCode || this.NewShippingAddress.ZipCode.trim().length == 0) return;
    var exists = this.B2BPartner?.ShippingAddresses?.some(
      (a: any) => a.ZipCode?.trim().toLowerCase() == this.NewShippingAddress.ZipCode.trim().toLowerCase()
    );
    if(exists){
      this.ShowZipCodeWarning = true;
    }
  }

  SaveNewShippingAddress(){
    if(!this.NewShippingAddress) return;
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ShippingAddress: this.NewShippingAddress,
      PartnerID: this.B2BPartner.ID
    };
    this.parent.loading = true;
    this.service.AddUpdateShippingAddress(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      } else {
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.ShowNewShippingAddressForm = false;
        this.NewShippingAddress = {};
        this.ShowZipCodeWarning = false;
        this.GetPartnerShippingAddresses(this.B2BPartner.ID);
      }
      this.parent.loading = false;
    });
  }

  // -- Agents --
  LoadPartnerAgents(){
    if(!this.B2BPartner?.ID) return;
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.B2BPartner.ID
    };
    this.parent.loading = true;
    this.service.GetPartnerAgents(request).subscribe(response => {
      if(response["Status"] == 1){
        this.PartnerAgents = response["PartnerAgents"] || [];
        // Load default phases for each agent
        this.loadAllAgentsDefaultPhases();
      }
      this.parent.loading = false;
    });
  }

  loadAllAgentsDefaultPhases(): void {
    if (!this.PartnerAgents?.length) return;
    this.PartnerAgents.forEach((agent: any) => {
      if (agent.ID > 0) {
        const req = { User: this.parent.User, Language: this.parent.getLanguage(), AgentID: agent.ID };
        this.service.GetPartnerAgentDefaultPhases(req).subscribe((res: any) => {
          if (res.Status === 1) {
            agent.OrderPhases = res.Phases || [];
          }
        });
      }
    });
  }

  EditAgent(a: any){
    this.EditingAgent = JSON.parse(JSON.stringify(a));
    this.ShowNewAgentForm = false;
  }

  CancelEditAgent(){
    this.EditingAgent = null;
  }

  SaveEditingAgent(){
    if(!this.EditingAgent) return;
    this.EditingAgent.PartnerID = this.B2BPartner.ID;
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerAgent: this.EditingAgent
    };
    this.parent.loading = true;
    this.service.AddUpdatePartnerAgent(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      } else {
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.EditingAgent = null;
        this.LoadPartnerAgents();
      }
      this.parent.loading = false;
    });
  }

  OpenNewAgentForm(){
    this.ShowNewAgentForm = true;
    this.EditingAgent = null;
    this.ShowAgentEmailWarning = false;
    this.NewAgent = {
      ID: 0,
      Name: '',
      Email: '',
      Phone: '',
      PartnerID: this.B2BPartner?.ID,
      Department: this.Departments?.length > 0 ? this.Departments[0] : null,
    };
  }

  CheckAgentEmailDuplicate(){
    this.ShowAgentEmailWarning = false;
    if(!this.NewAgent.Email || this.NewAgent.Email.trim().length == 0) return;
    var exists = this.PartnerAgents?.some(
      (a: any) => a.Email?.trim().toLowerCase() == this.NewAgent.Email.trim().toLowerCase()
    );
    if(exists){
      this.ShowAgentEmailWarning = true;
    }
  }

  SaveNewAgent(){
    if(!this.NewAgent) return;
    this.NewAgent.PartnerID = this.B2BPartner.ID;
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerAgent: this.NewAgent
    };
    this.parent.loading = true;
    this.service.AddUpdatePartnerAgent(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      } else {
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.ShowNewAgentForm = false;
        this.ShowAgentEmailWarning = false;
        this.NewAgent = {};
        this.LoadPartnerAgents();
      }
      this.parent.loading = false;
    });
  }

  DeleteAgent(agentID: number){
    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      AgentID: agentID
    };
    this.parent.loading = true;
    this.service.DeletePartnerAgent(request).subscribe(response => {
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      } else {
        this.PartnerAgents = this.PartnerAgents.filter(x => x.ID != agentID);
        this.EditingAgent = null;
      }
      this.parent.loading = false;
    });
  }

  // ========== DEFAULT AGENT PHASES MANAGEMENT ==========
  openDefaultPhasesPopup(): void {
    if (!this.EditingAgent?.ID) return;
    this.selectedDefaultPhaseAgent = this.EditingAgent;

    // Load masterdata if needed
    if (this.defaultPhasesMasterData.length === 0) {
      const req = { User: this.parent.User, Language: this.parent.getLanguage() };
      this.service.GetPartnersMasterData(req).subscribe((response: any) => {
        if (response.Status === 1) {
          this.defaultPhasesMasterData = response.PartnerAgentOrderPhases || [];
        }
      });
    }

    // Load current default phases for this agent
    const request = { User: this.parent.User, Language: this.parent.getLanguage(), AgentID: this.EditingAgent.ID };
    this.parent.loading = true;
    this.service.GetPartnerAgentDefaultPhases(request).subscribe((response: any) => {
      this.parent.loading = false;
      if (response.Status === 1) {
        this.EditingAgent.OrderPhases = response.Phases || [];
        this.selectedDefaultPhaseIDs = (response.Phases || []).map((p: any) => p.ID);
      }
      this.showDefaultPhasesPopup = true;
    });
  }

  closeDefaultPhasesPopup(): void {
    this.showDefaultPhasesPopup = false;
  }

  isDefaultPhaseSelected(phase: any): boolean {
    return this.selectedDefaultPhaseIDs.includes(phase.ID);
  }

  toggleDefaultPhase(phase: any): void {
    const idx = this.selectedDefaultPhaseIDs.indexOf(phase.ID);
    if (idx >= 0) {
      this.selectedDefaultPhaseIDs.splice(idx, 1);
    } else {
      this.selectedDefaultPhaseIDs.push(phase.ID);
    }
  }

  saveDefaultPhases(): void {
    if (!this.selectedDefaultPhaseAgent || this.savingDefaultPhases) return;

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      AgentID: this.selectedDefaultPhaseAgent.ID,
      PhaseIDs: this.selectedDefaultPhaseIDs
    };

    this.savingDefaultPhases = true;
    this.service.AddUpdatePartnerAgentDefaultPhases(request).subscribe((response: any) => {
      this.savingDefaultPhases = false;
      if (response.Status === 1) {
        this.selectedDefaultPhaseAgent.OrderPhases = response.Phases || [];
        // Sync on PartnerAgents list
        const match = this.PartnerAgents.find((a: any) => a.ID === this.selectedDefaultPhaseAgent.ID);
        if (match) match.OrderPhases = response.Phases || [];
        this.parent.openSnackBar(response.Message || 'Default phases saved', 'OK', 'light-info-snackbar');
        this.closeDefaultPhasesPopup();
      } else {
        this.parent.openSnackBar(response.Message || 'Error saving default phases', 'OK', 'alert-info-snackbar');
      }
    });
  }

}
